export class PaginatedMedicationRequest {
  readonly "@type": string;
  readonly skipIdList: number[];

  constructor(skipIds: number[]) {
    this["@type"] = ".PaginatedMedicationRequest";
    this.skipIdList = skipIds;
  }
}
